"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultProject = exports.projectSchema = exports.paymentSchema = exports.promoCodeSchema = exports.mountingSchema = exports.postMountingSchema = exports.sidePanelsSchema = exports.sidePanelSchema = exports.lightingSchema = exports.awningSchema = exports.awningPositionSchema = exports.awningOptionsSchema = exports.configurationSchema = exports.carportSchema = exports.customerSchema = exports.addressSchema = exports.projectStatusSchema = void 0;
const z = require("zod");
const bom_1 = require("./bom");
exports.projectStatusSchema = z.enum([
    "created",
    "planning",
    "planningComplete",
    "orderPlaced",
    "denied",
    "sentToManufacturer",
    "planningByManufacturer",
    "onSiteAppointment",
    "sentToConstructionMarket",
    "inProgress",
    "delivery",
    "deleted",
]);
exports.addressSchema = z.object({
    street: z.string(),
    houseNumber: z.string(),
    postalCode: z.string(),
    city: z.string(),
    federalState: z.string(),
});
exports.customerSchema = z.object({
    firstName: z.string(),
    lastName: z.string(),
    address: exports.addressSchema,
    tel: z.object({
        mobile: z.string(),
        landline: z.string(),
    }),
    email: z.string(),
    availability: z.string().nullable(),
    referrer: z.string().nullable(),
    salesman: z.string().nullable(),
    includeMounting: z.boolean().nullable(),
    continueWithSalesman: z.boolean().nullable(),
    deliveryPreferences: z.string().nullable(),
});
exports.carportSchema = z.object({
    carportOrientation: z.number().nullable(),
    carportPosition: z.number().nullable(),
    carportVariantId: z.string().nullable(),
    carportEntry: z.string().nullable(),
    carportFastning: z.string().nullable(),
    carportSize: z.string().nullable(),
    solarVariant: z.string().nullable(),
});
exports.configurationSchema = z.object({
    width: z.number().nullable(),
    depth: z.number().nullable(),
    heightWall: z.number().nullable(),
    heightGutter: z.number().nullable(),
    colorCode: z.number().nullable(),
    colorHasStructure: z.boolean().nullable(),
    isCustomColor: z.boolean().nullable(),
    roofingVariant: z.string().nullable(),
    additionalPostCount: z.number().nullable(),
    postCount: z.number().nullable(),
    postOffsets: z.number().array(),
    postVariant: z.string().nullable(),
    mountingHeightWall: z.number().nullable(),
    mountingHeightWindow: z.number().nullable(),
    heightDifferenceOfRoofAndHouse: z.number().nullable(),
    gableSide: z.boolean().nullable(),
    medianHeightOfHouse: z.number().nullable(),
    carport: exports.carportSchema.nullable(),
});
exports.awningOptionsSchema = z.object({
    engineSide: z.string().nullable(),
});
exports.awningPositionSchema = z.object({
    start: z.number().nullable(),
    end: z.number().nullable(),
});
exports.awningSchema = z.object({
    variant: z.enum(["under_glass", "on_roof"]).nullable(),
    controls: z.enum(["motor", "motor_funk", "motor_io"]).nullable(),
    roofAwnings: z.object({
        awnings: exports.awningOptionsSchema.merge(exports.awningPositionSchema).array(),
        fabricBrand: z.string().nullable(),
        fabricID: z.string().nullable(),
    }),
    frontAwnings: z.object({
        awnings: exports.awningOptionsSchema.merge(exports.awningPositionSchema).array(),
        fabricBrand: z.string().nullable(),
        fabricID: z.string().nullable(),
    }),
    awningLeft: z.object({
        sideAwningVariant: z.string().nullable(),
        awning: exports.awningOptionsSchema.nullable(),
        fabricBrand: z.string().nullable(),
        fabricID: z.string().nullable(),
        mountingPostPosition: z.enum(["on_posts", "between_posts"]).nullable(),
    }),
    awningRight: z.object({
        sideAwningVariant: z.string().nullable(),
        awning: exports.awningOptionsSchema.nullable(),
        fabricBrand: z.string().nullable(),
        fabricID: z.string().nullable(),
        mountingPostPosition: z.enum(["on_posts", "between_posts"]).nullable(),
    }),
    mountingPostPosition: z.enum(["on_posts", "between_posts"]).nullable(),
    mounting: z.boolean().nullable(),
    fabricBrand: z.string().nullable(),
    wsGuard: z.boolean().nullable(),
});
exports.lightingSchema = z.object({
    lighting: z.boolean().nullable(),
    additionalLighting: z.boolean().nullable(),
    variant: z.string().nullable(),
    additionalVariant: z.string().nullable(),
    amount: z.number().nullable(),
    additionalAmount: z.number().nullable(),
    radiantHeater: z.boolean().nullable(),
    heaterWireless: z.boolean().nullable(),
    radiantHeaterAmount: z.number().nullable(),
    powerLightingFields: z.boolean().nullable().array(),
    soundSystem: z.boolean().nullable(),
});
exports.sidePanelSchema = z.object({
    side: z.string().nullable(),
    panelOpt: z.string().nullable(),
    variant: z.string().nullable(),
    width: z.number().nullable(),
    accessories: z.string().nullable(),
    plankHeight: z.number().nullable(),
    opening: z.string().nullable(),
});
exports.sidePanelsSchema = z.object({
    sidePanels: exports.sidePanelSchema.nullable().array().nullable(),
    mounting: z.boolean().nullable(),
});
exports.postMountingSchema = z.object({
    foundation: z.string().nullable(),
    groundAdjustment: z.boolean().nullable(),
});
exports.mountingSchema = z.object({
    wall: z.string().nullable(),
    wallThickness: z.number().nullable(),
    wallMaterial: z.string().nullable(),
    mountingVariant: z.string().nullable(),
    rearPosts: z.number().nullable(),
    rearPostsLength: z.number().nullable(),
    measuring: z.string().nullable(),
    measurement: z.number().nullable(),
    postMountingFront: exports.postMountingSchema.array().nullable(),
    postMountingRear: exports.postMountingSchema.array().nullable(),
    consoleAmount: z.number().nullable(),
    thermoDowels: z.boolean().nullable(),
    foundationSide: z.string().nullable(),
    downpipeDuct: z.boolean().nullable(),
});
exports.promoCodeSchema = z.object({
    market: z.string().array(),
    value: z.string(),
    text: z.string(),
    amount: z.number().nullable(),
    active: z.boolean(),
});
exports.paymentSchema = z.object({
    paymentOption: z.string().nullable(),
    discount: z.number().nullable(),
    specialDiscount: z.number().nullable(),
    extra: z.string().nullable(),
    promoCode: exports.promoCodeSchema.nullable(),
});
exports.projectSchema = z.object({
    id: z.number(),
    type: z.string().optional(),
    schemaVersion: z.number().optional(),
    market: z
        .object({
        marketNumber: z.number(),
        type: z.string(),
    })
        .nullable(),
    retrievalNumberPlanning: z.string().nullable(),
    retrievalNumberOrder: z.string().nullable(),
    orderPlaced: z.boolean(),
    status: exports.projectStatusSchema,
    customer: exports.customerSchema,
    configuration: exports.configurationSchema,
    awning: exports.awningSchema,
    lighting: exports.lightingSchema,
    sidePanels: exports.sidePanelsSchema,
    mounting: exports.mountingSchema,
    payment: exports.paymentSchema,
    bom: bom_1.bomSchema,
    owner: z.string(),
    createdAt: z.date(),
    lastUpdated: z.date(),
});
exports.defaultProject = {
    id: 0,
    schemaVersion: 8.2,
    type: "roof",
    market: null,
    retrievalNumberPlanning: null,
    retrievalNumberOrder: null,
    orderPlaced: false,
    status: "planning",
    customer: {
        firstName: "",
        lastName: "",
        address: {
            street: "",
            houseNumber: "",
            postalCode: "",
            city: "",
            federalState: "",
        },
        tel: {
            mobile: "",
            landline: "",
        },
        email: "",
        availability: null,
        referrer: null,
        salesman: null,
        includeMounting: null,
        continueWithSalesman: null,
        deliveryPreferences: null,
    },
    configuration: {
        width: null,
        depth: null,
        heightWall: null,
        heightGutter: null,
        colorCode: null,
        colorHasStructure: null,
        isCustomColor: null,
        roofingVariant: null,
        additionalPostCount: null,
        postCount: null,
        postOffsets: [],
        postVariant: null,
        mountingHeightWall: null,
        mountingHeightWindow: null,
        heightDifferenceOfRoofAndHouse: null,
        gableSide: false,
        medianHeightOfHouse: null,
        carport: null,
    },
    awning: {
        variant: null,
        controls: null,
        roofAwnings: {
            awnings: [],
            fabricID: null,
            fabricBrand: null,
        },
        frontAwnings: {
            awnings: [],
            fabricID: null,
            fabricBrand: null,
        },
        awningLeft: {
            sideAwningVariant: null,
            awning: null,
            fabricID: null,
            fabricBrand: null,
            mountingPostPosition: null,
        },
        awningRight: {
            sideAwningVariant: null,
            awning: null,
            fabricID: null,
            fabricBrand: null,
            mountingPostPosition: null,
        },
        mountingPostPosition: null,
        mounting: null,
        fabricBrand: null,
        wsGuard: null,
    },
    lighting: {
        lighting: null,
        additionalLighting: null,
        variant: null,
        additionalVariant: null,
        amount: 0,
        additionalAmount: 0,
        radiantHeater: null,
        heaterWireless: null,
        radiantHeaterAmount: null,
        powerLightingFields: [],
        soundSystem: null,
    },
    sidePanels: {
        sidePanels: null,
        mounting: null,
    },
    mounting: {
        wall: null,
        wallThickness: null,
        wallMaterial: null,
        mountingVariant: null,
        rearPosts: null,
        rearPostsLength: null,
        measuring: null,
        measurement: null,
        postMountingFront: null,
        postMountingRear: null,
        consoleAmount: null,
        thermoDowels: null,
        foundationSide: null,
        downpipeDuct: null,
    },
    payment: {
        paymentOption: null,
        discount: null,
        specialDiscount: null,
        extra: null,
        promoCode: null,
    },
    bom: {
        groups: [
            {
                description: "",
                totalPrice: 0,
                totalPurchasePrice: 0,
                totalSalesPrice: 0,
                items: [
                    {
                        amount: 0,
                        totalPrice: 0,
                        totalPurchasePrice: 0,
                        totalSalesPrice: 0,
                        article: {
                            type: null,
                            _id: 0,
                            description: "",
                            price: 0,
                            purchasePrice: null,
                            salesPrice: null,
                            unit: "",
                            category: "",
                            width: null,
                            depth: null,
                        },
                    },
                ],
            },
        ],
        totalPrice: 0,
        totalPurchasePrice: 0,
        totalSalesPrice: 0,
    },
    owner: "",
    createdAt: new Date(0),
    lastUpdated: new Date(0),
};
//# sourceMappingURL=project.js.map